import React from 'react';
import { Col, Row } from '@thd-olt-component-react/grid';
import {
  extend,
  QueryContext
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { LayoutGroup, LayoutManager } from '@thd-olt-component-react/layout-manager';
import { NationalDirectory, MostSearchedStores } from '@thd-olt-component-react/store-directory';
import { declareContexts } from '@thd-olt-component-react/hydrator';
import { Metadata } from '@thd-olt-component-react/metadata';

export const Directory = () => {
  declareContexts([QueryContext, ExperienceContext]);
  const metaDataProperties = {
    canonicalURL: '/l/storeDirectory',
    title: 'Home Depot Stores - Search Results'
  }
  return (
    <>
      <LayoutManager name="sf-directory-wrapper" useContextForProps>
        <LayoutGroup name="national-directory-content">
          <Metadata data={metaDataProperties} />
        </LayoutGroup>
        <LayoutGroup name="sf-directory-content">
          <div className="zone-card">
            <Row className="isBound">
              <Col xs={12}>
                <NationalDirectory />
              </Col>
              <Col xs={12}>
                <MostSearchedStores />
              </Col>
            </Row>
          </div>
        </LayoutGroup>
      </LayoutManager>
    </>
  );
};

Directory.displayName = 'StoreDirectory';
Directory.propTypes = {};

Directory.dataModel = extend({},
  NationalDirectory,
  MostSearchedStores
);
